export const feetToMeterConverter = (value: number) => {
  const newValue = value / 3.2808399
  return Number(newValue.toFixed(0))
}
